import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthCheck } from '../auth/auth.check';
import { HistoryComponent } from './history/history.component';
import { RunManagementComponent } from './run-management/run-management.component';
import { TestCaseComponent } from './test-case/test-case.component';

import { TestStepComponent } from './test-step/test-step.component';
import { FlowChartComponent } from './test-step/flow-chart/flow-chart.component';


const routes: Routes = [ 
{
  path: 'test-history/:pid', component: HistoryComponent
  ,canActivate:[AuthCheck]},
{
  path: 'TestSuit/:pid/:tid', component: TestCaseComponent
  ,canActivate:[AuthCheck]},
{
  path: 'TestStep/:pid/:tid/:tsid', component: TestStepComponent
  ,canActivate:[AuthCheck]},
{
  path: 'run-management/:pid', component: RunManagementComponent
  ,canActivate:[AuthCheck]},

{ path: 'flow-chart/:pid/:tid/:tsid', component: FlowChartComponent},

];

@NgModule({
  imports: [
    CommonModule,//
    RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TestRoutingModule { }


